module.exports = __webpack_public_path__ + "static/media/diary-alt.16fb54eb.svg";